/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@gvlab/react-theme/styles';
import Page from '@gvlab/react-ui/components/Page';
import VersionPanel from '@gvlab/react-ui/components/VersionPanel';
import { Suspense } from '@gvlab/react-create-app-gv';
import { Box, Divider } from '@gvlab/react-theme/mui';
import { selectAuthen, init } from 'store/Auth/recoverSlice';
import { Alert } from '@gvlab/react-ui/components';

import { Form1, Form2, Form3 } from './components';

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 1),
}));

const UserLogin = () => {
  const authen = useSelector(selectAuthen);
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();

  console.log('authen', authen);
  return (
    <Page title="Sign In" className="flex flex-col dark:bg-gray-900 dark:text-gray-100">
      {authen.state === 'success' && <Form3 />}
      {authen.state !== 'success' && (
        <div>
          <div className="mb-8 text-left">
            <h1 className="my-3 text-4xl font-bold text-black dark:text-gray-400">
              Forgot password?
            </h1>
          </div>
          <Suspense>
            {authen.state === 'idle' && <Form1 />}
            {['otp', 'otp-pending', 'otp-error'].includes(authen.state) && <Form2 />}
          </Suspense>
          {authen.errors && authen.errors.message && (
            <Alert
              severity="error"
              message={authen.errors.message}
              onClose={() => {
                dispatch(init());
              }}
            />
          )}
        </div>
      )}
      <StyledDivider />
      <Box m={2}>
        <VersionPanel copyright="houzmoni sdn. bhd." />
      </Box>
    </Page>
  );
};

export default UserLogin;
